import React from "react";
import './index.css'

const WithLogoText = ({children, matchInfo, filterByGroup})=>{
    const title = !filterByGroup ? matchInfo?.jornada?.toUpperCase() : matchInfo?.equipoLocal?.grupo?.toUpperCase()
    console.log('tag', matchInfo?.jornada?.toUpperCase())
    return(
        <div style={{backgroundColor:'#24204b'}}>
            <div style={{textAlign:'center'}}>
                <p className="title-banner" style={{color:'gold', fontWeight:'bolder', fontSize:'40px', letterSpacing:'1px'}}>{title}</p>
            </div>
            {children}
            <div style={{display:'flex', justifyContent:'center', marginTop:'10px'}}>
                <img width={130} height={130}  src={matchInfo?.torneo?.imgPicture}/>

            </div>
        </div>
    )
}

export default WithLogoText